import React, { useState } from 'react';
import { Task, TaskStage } from '../../../../types/Task';
import { taskService } from '../../../../services/quantifiedTaskService';
import { useAuth } from '../../../../contexts/AuthContext';
import { Button, Form, Modal } from '@/components/ui';

interface RequestCorrectionModalProps {
  visible: boolean;
  onClose: () => void;
  task: Task;
  onSubmit: (taskId: number, comments: string) => Promise<void>;
}

const RequestCorrectionModal: React.FC<RequestCorrectionModalProps> = ({
  visible,
  onClose,
  task,
  onSubmit,
}) => {
  const [comments, setComments] = useState('');
  const [loading, setLoading] = useState(false);
  const { currentUser } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setLoading(true);
      await taskService.requestCorrection(task.id, {
        comments,
        userId: currentUser?.id,
        taskId: task.id
      });
      onSubmit(task.id, comments);
      onClose();
    } catch (error) {
      console.error('Error requesting correction:', error);
      alert('Failed to request correction');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={visible} onHide={onClose} backdrop={loading ? 'static' : true}>
      <Modal.Header closeButton>
        <Modal.Title>Request Correction</Modal.Title>
      </Modal.Header>
      {/* Form wraps Body+Footer (footer holds the submit) and is the flex column itself. */}
      <form onSubmit={handleSubmit} className="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col">
        <Modal.Body>
          <Form.Group className="tw-mb-3">
            <Form.Label>Comments</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={comments}
              onChange={(e) => setComments(e.target.value)}
              required
              placeholder="Please provide your comments..."
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            disabled={loading || !comments.trim()}
          >
            {loading ? 'Submitting...' : 'Submit'}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default RequestCorrectionModal; 